import { applyMiddleware, createStore } from 'redux'
import appMainReducer from './reducers'
import { routerMiddleware } from 'react-router-redux'
// import { routerMiddleware } from 'connected-react-router'

import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'

import { storageMiddlewareProvider } from './storageMiddleware'
import { observedActions } from './config/observed_actions'

let store = null

export default function configureStore (history) {
  if (!store) {
    const storageMiddleware = storageMiddlewareProvider(observedActions)
    const middlewares = [
      thunk,
      routerMiddleware(history),
      storageMiddleware
    ]

    middlewares.push(createLogger({ collapsed: true }))
    store = createStore(
      appMainReducer,
      {},
      applyMiddleware(...middlewares)
    )
  }
  return store
}
